import api from "@/config/axios";
import axios from "axios";
const URL_API = "https://mindicador.cl/api/";

export default {
  valores() {
    return axios.get(URL_API);
  },
  valoresBD() {
    return api.get(`system/indicadores`);
  },
};
